import { Component, NgZone, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  constructor(private route: Router, public zone: NgZone) {}

  ngOnInit(): void {}

  startApp() {
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      preserveFragment: true,
      state: { reload: true }
    };
    this.zone.run(() => { 
      this.route.navigate(['/'], navigationExtras);
    });
  }
}
